// extracted by mini-css-extract-plugin
export default {"columns":"risk_columns__FIjvx","description":"risk_description__bn366","status":"risk_status__MH2zX","statsInfo":"risk_statsInfo__f6+qG"};